import React from 'react'

const Logo = ({name = "SINIS"}) => {
    return ( 
        <div className='logo'>
            <img src="./images/logo3.svg" alt="SINIS GmbH Logo" width="40" height="40" />
            <p>{name}</p>
        </div> 
    );
}
 
export default Logo;